// extracted by mini-css-extract-plugin
export default {"page":"styles_page__B1REC","heading":"styles_heading__CfTbZ"};